import React from 'react'
import classes from './pagechanger.module.css'
import LeftIcon from '../../assets/icons/left.svg'
import RightIcon from '../../assets/icons/right.svg'

// const onClick = (actionType, pageNum) => ({
//     actionType,
//     pageNum
// })

const PageChanger = ({ pageCount, onPageChange, currentPage }) => {
    const minPage = Math.max(1, currentPage - 2)
    const maxPage = Math.min(pageCount, currentPage + 2)
    const pagesArray = Array(maxPage - minPage + 1).fill(null)
    return (
        <div className={classes.pageChanger}>
            <button
                className={classes.pageChangeButton}
                disabled={currentPage === 1}
                onClick={() => {
                    const page = currentPage > 1 ? currentPage - 1 : 1
                    return onPageChange(page)
                }}
            >
                <img
                    src={LeftIcon}
                    alt="previous page"
                    className={classes.pageChangeButtonImage}
                />
            </button>
            <div className={classes.pagesWrapper}>
                {minPage !== 1 ? (
                    <>
                        <button
                            className={[
                                classes.pageButton,
                                currentPage === 1 && classes.pageButtonActive,
                            ].join(' ')}
                            onClick={() => currentPage !== 1 && onPageChange(1)}
                        >
                            1
                        </button>
                        …
                    </>
                ) : null}
                {pagesArray.map((_, idx) => (
                    <button
                        className={[
                            classes.pageButton,
                            currentPage === idx + minPage &&
                                classes.pageButtonActive,
                        ].join(' ')}
                        onClick={() =>
                            currentPage !== idx + minPage &&
                            onPageChange(idx + minPage)
                        }
                    >
                        {idx + minPage}
                    </button>
                ))}
                {maxPage !== pageCount ? (
                    <>
                        …
                        <button
                            className={[
                                classes.pageButton,
                                currentPage === pageCount &&
                                    classes.pageButtonActive,
                            ].join(' ')}
                            onClick={() =>
                                currentPage !== pageCount &&
                                onPageChange(pageCount)
                            }
                        >
                            {pageCount}
                        </button>
                    </>
                ) : null}
            </div>
            <button
                className={classes.pageChangeButton}
                disabled={currentPage === pageCount}
                onClick={() => {
                    const page =
                        currentPage < pageCount ? currentPage + 1 : pageCount
                    return onPageChange(page)
                }}
            >
                <img
                    src={RightIcon}
                    alt="previous page"
                    className={classes.pageChangeButtonImage}
                />
            </button>
        </div>
    )
}

export default PageChanger
